export default () => {
  return [
    {
      label: 'DCI',
      unit: 'A',
      display: true,
      fullform: 'DC current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'DCV',
      unit: 'V',
      display: true,
      fullform: 'DC bus voltage',
      yAxis: 'Voltage',
      loading: false
    },
    {
      label: 'OPW',
      unit: 'kW',
      display: false,
      fullform: 'Output power',
      yAxis: 'Power',
      loading: false
    },
    {
      label: 'OPF',
      unit: 'Hz',
      display: false,
      fullform: 'Frequency',
      yAxis: 'Frequency',
      loading: false
    },
    {
      label: 'OPC',
      unit: 'A',
      display: false,
      fullform: 'Load current',
      yAxis: 'Current',
      loading: false
    },
    {
      label: 'ITP',
      unit: '°C',
      display: false,
      fullform: 'IGBT core temperature',
      yAxis: 'Temperature',
      loading: false
    },
    {
      label: 'IFLT',
      unit: '',
      display: false,
      fullform: 'Fault code',
      yAxis: 'Fault/Status',
      loading: false
    },
    {
      label: 'BIN_STATUS',
      unit: '',
      display: false,
      fullform: 'Binary status',
      yAxis: 'Fault/Status',
      loading: false
    },
    {
      label: 'SNG',
      unit: 'dBm',
      display: false,
      fullform: 'Signal strength',
      yAxis: 'Signal Strength',
      loading: false
    },
    {
      label: 'ENERGY_IN',
      unit: 'kWh',
      display: false,
      fullform: 'Energy input',
      yAxis: 'Energy',
      loading: false
    },
    {
      label: 'SYS_UPTIME',
      unit: 'sec',
      display: false,
      fullform: 'System Uptime',
      yAxis: 'Time',
      loading: false
    }
  ];
};
